import useTranslation from "@/hooks/useTranslation";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Popconfirm, Tooltip, message } from "antd";
import { ReactNode } from "react";
import { Consumable } from "./ConsumableOverview/ConsumableOverview";
import { useDeleteConsumable } from "./useConsumables";

export default function DeleteProductAction({
  children,
  consumable,
  onSucces,
}: {
  children: ReactNode;
  consumable: Consumable;
  onSucces?: () => void;
}) {
  const deleteConsumable = useDeleteConsumable();
  const translation = useTranslation();

  return (
    <Popconfirm
      title={`Delete consumable`}
      description={
        <>
          <p>You are about to delete a consumable.</p>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      onConfirm={() =>
        deleteConsumable
          .mutateAsync({ consumableId: consumable.id })
          .then((result) => {
            if (result.status === 200) {
              message.success(`Consumable has been deleted.`);
              onSucces && onSucces();
            }
          })
          .catch(() => message.error(translation.errors.general))
      }
      onCancel={() => {}}
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      okText={`Delete consumable`}
      cancelText="Cancel"
      placement="bottom"
      okType="danger"
      okButtonProps={{ loading: deleteConsumable.isLoading }}
      disabled={!consumable.deletable}
    >
      <Tooltip
        placement="bottom"
        title={
          !consumable.deletable && (
            <span>
              This consumable can not be deleted as it is referenced in a product or facility.
            </span>
          )
        }
      >
        {children}
      </Tooltip>
    </Popconfirm>
  );
}
